<script>
  import { onMount } from "svelte";
  import { Loading } from "carbon-components-svelte";

  import Header from "lib/components/Header.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import TableFilterable from "../../../../lib/components/TableFilterable.svelte";

  let headers = [
    { key: "applicationname", value: "Application", width: "auto" },
    { key: "windowtitle", value: "Windows tittle", width: "auto" },
    { key: "eventtype", value: "UI-Name", width: "150px" },
    { key: "automationid", value: "Automation ID", width: "auto" },
    { key: "type", value: "Type", width: "150px" },
    { key: "count", value: "Range filter", width: "130px", filterable: false },
  ];

  export let analysisid;

  let uilistfilterelements = {
    applicationname: [],
    type: [],
    windowtitle: [],
  };

  let loading = true;

  let fulluilist = [];

  let uilistfilter = {
    applicationname: "",
    windowtitle: "",
    automationid: "",
    type: "",
    eventtype: "",
  };

  function getUIElements() {
    loading = true;
    fetchWithSession(
      `/api/analysis/getUIlog/grouped-by-app?analysisid=` + analysisid
    )
      .then((res) => res.json())
      .then((data) => {
        fulluilist = data;
        loading = false;
        getFilteredElements();
      })
      .catch((err) => {
        console.error(err);
        loading = false;
      });
  }

  function getFilteredElements() {
    headers.forEach(header => {
      if (uilistfilterelements.hasOwnProperty(header.key)) {
        fulluilist.forEach(element => {
          if (uilistfilterelements[header.key] && !uilistfilterelements[header.key].includes(element[header.key])) {
            uilistfilterelements[header.key].push(element[header.key]);
          }
       });
      }
    });
  }

  onMount(() => {
    getUIElements();
  });
</script>



<Header section="Preprocessing" breadcrumb="Overview">
  
</Header>
{#if loading}
  <Loading />
{:else}
  <TableFilterable
    {fulluilist}
    isCompleted={loading}
    {headers}
    {uilistfilter}
    {uilistfilterelements}
    functionButton={false}
  />
{/if}
